import type { BrokerAccountRef } from "@/utils/brokerAccountRef";
import type { WorkspaceNode } from "../../../types/workspace";

export type WorkspaceExecutingAccountDrawerTarget = {
  id: string;
  account: BrokerAccountRef;
  label: string;
  parentPolicyNode: WorkspaceNode;
};

export type WorkspaceDrawerEntry =
  | { kind: "node"; node: WorkspaceNode }
  | { kind: "executing-account"; target: WorkspaceExecutingAccountDrawerTarget };

export function workspaceDrawerEntryId(entry: WorkspaceDrawerEntry): string {
  return entry.kind === "node" ? entry.node.id : entry.target.id;
}

/** Strategy entity id for the pine dock — prefers an open strategy sheet over canvas selection. */
export function resolveWorkspacePineStrategyEntityId(
  drawerEntries: WorkspaceDrawerEntry[],
  detail: { nodes: WorkspaceNode[] } | null | undefined,
  selectedNodeId: string | null
): string | null {
  for (let index = drawerEntries.length - 1; index >= 0; index -= 1) {
    const entry = drawerEntries[index];
    if (entry?.kind === "node" && entry.node.type === "strategy") {
      const entityId = entry.node.entityId?.trim();
      if (entityId) return entityId;
    }
  }

  if (!detail || !selectedNodeId) return null;
  const node = detail.nodes.find((entry) => entry.id === selectedNodeId);
  if (!node || node.type !== "strategy") return null;
  const entityId = node.entityId?.trim();
  return entityId || null;
}
